export const CUSTOM_EVENT_NAME = 'globalDialog';
